const RunningStates = {
  IDLE: "IDLE",
  RUNNING: "RUNNING",
  COMPLETE: "COMPLETE",
  CANCELLED: "CANCELLED"
}

export default RunningStates;
